import { logger } from 'utils/logger';

// Logs a re-capture failure that left a live stream intact (device switch / VB reset).
// Unlike reportMediaCaptureFailure, it doesn't mark the device kind denied.
export const logSwitchCaptureFailure = (operation: string, error: unknown): void => {
  const detail = error instanceof Error ? { name: error.name, message: error.message } : { error };
  logger
    .remote({ capture: 'user_media' })
    .warn(`${operation} capture failed; keeping current stream`, detail);
};
